/**
 * SIORG List reducer.
 * @module reducers/toolbar/toolbar
 */

import { GET_SIORG_ORGANS_LIST } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  data: [],
};

/**
 * SIORG List reducer.
 * @function site
 * @param {Object} state Current state.
 * @param {Object} action Action to be handled.
 * @returns {Object} New state.
 */
export default function siorg_organs_list(state = initialState, action = {}) {
  switch (action.type) {
    case `${GET_SIORG_ORGANS_LIST}_PENDING`:
      return {
        ...state,
        error: null,
        loaded: false,
        loading: true,
        data: [],
      };
    case `${GET_SIORG_ORGANS_LIST}_SUCCESS`:
      return {
        ...state,
        error: null,
        loaded: true,
        loading: false,
        data: Array.isArray(action.result) ? action.result : [],
      };
    case `${GET_SIORG_ORGANS_LIST}_FAIL`:
      return {
        ...state,
        error: action.result,
        loaded: false,
        loading: false,
        data: [],
      };
    default:
      return state;
  }
}
